module.exports = __webpack_public_path__ + "static/img/egg_r_06.622c646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_06.png
// module id = jI/6
// module chunks = 1